var map = {
	"./kensa6_1.jpg": 4522,
	"./kensa6_10.jpg": 5016,
	"./kensa6_11.jpg": 2629,
	"./kensa6_12.jpg": 5402,
	"./kensa6_13.jpg": 7335,
	"./kensa6_14.jpg": 7100,
	"./kensa6_15.jpg": 1241,
	"./kensa6_16.jpg": 9742,
	"./kensa6_17.jpg": 9899,
	"./kensa6_18.jpg": 4592,
	"./kensa6_19.jpg": 6333,
	"./kensa6_1_p.jpg": 2491,
	"./kensa6_2.jpg": 5013,
	"./kensa6_20.jpg": 1545,
	"./kensa6_21.jpg": 7196,
	"./kensa6_22.jpg": 2363,
	"./kensa6_23.jpg": 2878,
	"./kensa6_24.jpg": 9941,
	"./kensa6_2_p.jpg": 5328,
	"./kensa6_3.jpg": 3832,
	"./kensa6_3_p.jpg": 9525,
	"./kensa6_4.jpg": 7435,
	"./kensa6_5.jpg": 1598,
	"./kensa6_6.jpg": 6617,
	"./kensa6_7.jpg": 2268,
	"./kensa6_8.jpg": 15,
	"./kensa6_9.jpg": 7346,
	"./kensa6_example.jpg": 605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6142;